import classNames from 'classnames';

import styles from './Jumbotron.module.scss';

interface OwnProps {
  children?: React.ReactNode;
  flexHeight?: boolean;
}

const Jumbotron: React.FC<OwnProps> = ({ children, flexHeight = false }) => (
  <div
    className={classNames(styles.wrapper, {
      [styles.flexHeight]: flexHeight,
    })}
  >
    {children}
  </div>
);

export default Jumbotron;
